module.exports = __webpack_public_path__ + "static/img/ind2.85230da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/indicadores/ind2.png
// module id = jnq8
// module chunks = 3